import { makeStyles } from '@material-ui/core';

export const pagamentoContratoStyles = makeStyles({
  buttonAdicionarEmail: {
    color: '#53c4e6',
    fontSize: 15,
    marginTop: 8,
  },
});
